export default __webpack_public_path__ + "5eeb37038488d11d4e6ebf2080e8f40c.svg";